import { Injectable } from '@angular/core';
import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { SolutionModel } from '@app/src/app/modules/solution/classes/default/model/solution.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class SolutionRequestMutation extends AbstractGraphqlRequest<SolutionModel> {
  protected override type: GraphqlRequestType = 'mutation';

  protected override getQuery(payload: any): TypedDocumentNode<any, any> {
    if (payload.data?.id) {
      return gql`
        mutation updateSolution($data: SolutionUpdateInput!) {
          updateSolution(data: $data) {
            id
            category {
              id
              title
              description
            }
            cover {
              id
              name
              originalName
              extension
              active
              title
              description
              directory
              directories
              chunkEnd
              chunkStart
              frontUrls

              mimetype
              temp
              createdAt
              updatedAt
              createdBy
              updatedBy
            }
            picture {
              id
              name
              originalName
              extension
              active
              title
              description
              directory
              directories
              chunkEnd
              chunkStart
              frontUrls

              mimetype
              temp
              createdAt
              updatedAt
              createdBy
              updatedBy
            }
            slug
            title
            description
            shortDescription
            active
            createdAt
            updatedAt
            deletedAt
            createdBy
            updatedBy
          }
        }
      `;
    }

    return gql`
      mutation createSolution($data: SolutionCreateInput!) {
        createSolution(data: $data) {
          id
          category {
            id
            title
            description
          }
          cover {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          picture {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          slug
          title
          description
          shortDescription
          active
          createdAt
          updatedAt
          deletedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    const solutionData = data.createSolution || data.updateSolution;

    if (solutionData) {
      return new SolutionModel(solutionData);
    }

    return null;
  }
}
